/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n'
import { Fragment } from '@wordpress/element'
import {
	BlockControls,
	RichText
} from '@wordpress/block-editor'

/**
 * Internal dependencies
 */
import { i18n } from 'cartzillagb'
import HeadingToolbar from './heading-toolbar'

const Heading = props => {
	const {
		className,
		placeholder = __( 'Title for This Block', i18n ),
		value,
		onChangeValue,
		tagLevel = 3,
		onChangeTagLevel,
	} = props

	const tagName = 'h' + tagLevel

	return (
		<Fragment>
			<BlockControls>
				<HeadingToolbar
					minLevel={ 1 }
					maxLevel={ 7 }
					selectedLevel={ tagLevel }
					onChange={ onChangeTagLevel }
				/>
			</BlockControls>
			<RichText
				tagName={ tagName }
				value={ value }
				className={ className }
				placeholder={ placeholder }
				onChange={ onChangeValue }
				keepPlaceholderOnFocus
			/>
		</Fragment>
	)
}

Heading.Content = props => {
	const {
		className,
		value,
		tagLevel,
	} = props

	const tagName = 'h' + tagLevel

	return (
		<RichText.Content
			tagName={ tagName }
			value={ value }
			className={ className }
		/>
	)
}

export default Heading